import { ApiHelper, IApiResponse } from "../../utils/api-helper";

export type GroupCodeType =
  | "ORGTYPE"
  | "FIELD"
  | "SFIELD"
  | "PDA"
  | "FDA"
  | "DCal"
  | "PLSTATUS"
  | "PLR"
  | "PJTYPE"
  | "PAYSRC"
  | "PAYTYPE"
  | "PPStatus"
  | "PPPStatus"
  | "EDOBJ"
  | "EDPT"
  | "ORGSTATUS"
  | "SOURCELOAN"
  | "PROVINCE"
  | "OPRSTATUS"
  | "CRDCN"
  | "SDG"
  | "SDGSUB"
  | "GroupFTyp"

const url = `${process.env.REACT_APP_API_ENDPOINT}/organizations`;

class OrgService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getPDMOLawReguration(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id, { name: "PDMOLawReguration" });
    } catch (e) {
      throw e;
    }
  }

  public getOrgDashboard(): Promise<IApiResponse | void> {
    try {
      return super.get(undefined, { name: "countbytype" });
    } catch (e) {
      throw e;
    }
  }

  public getOrgAffiliates(): Promise<IApiResponse | void> {
    try {
      return super.get(undefined, { name: "affiliates" });
    } catch (e) {
      throw e;
    }
  }

  public getOrganizeList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public getOrganizeChangeRequest(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id, { name: "changeRequest" });
    } catch (e) {
      throw e;
    }
  }

  public createOrganize(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body);
    } catch (e) {
      throw e;
    }
  }

  public getChangeRequestList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "changerequestlist" });
    } catch (e) {
      throw e;
    }
  }

  public approveRequest(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id, { name: "approverequest" });
    } catch (e) {
      throw e;
    }
  }

  public cancelRequest(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id, { name: "cancelrequest" });
    } catch (e) {
      throw e;
    }
  }

  public createOrUpdateRequest(
    body: any,
    id: number,
  ): Promise<IApiResponse | void> {
    try {
      return super.update(body, id, { name: "changeRequest" });
    } catch (e) {
      throw e;
    }
  }

  public calculateORGStatus(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "CalculateORGStatus" });
    } catch (e) {
      throw e;
    }
  }
}
const orgAPI = new OrgService(url);
export default orgAPI;
